import { getRouteApi } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ElasticToggleGroup } from '~/ui/molecules';

import {
  DATE_RANGE_NAMES_ORDER,
  DATE_RANGE_OPTIONS,
  DateRangeNameOption,
} from '../constants';

type P = ComponentStyling;

/**
 * DateRangeSelect
 *
 * Allows selecting a date range from a list of predefined options (7, 30, 90, or 180 days).
 */
export const DateRangeSelect = ({ className, style }: P) => {
  const { t } = useTranslation('analytics');

  const AnalyticsUsageRoute = getRouteApi('/(main)/analytics/usage/');

  const navigate = AnalyticsUsageRoute.useNavigate();

  const dateRangeName = AnalyticsUsageRoute.useSearch({
    select: ({ dateRangeName }) => dateRangeName as DateRangeNameOption,
  });

  function onSelectDateRangeName(selectedDateRangeName: DateRangeNameOption) {
    navigate({
      search: (previous) => ({
        ...previous,
        dateRangeName: selectedDateRangeName,
        page: 0, // Reset table page when changing date range
      }),
    });
  }

  return (
    <div className={className} style={style}>
      <ElasticToggleGroup<DateRangeNameOption>
        aria-label={t(($) => $.usage.dateRange.label)}
        className="-ml-1"
        options={DATE_RANGE_NAMES_ORDER.map((value) => ({
          label: DATE_RANGE_OPTIONS[value],
          value,
        }))}
        value={dateRangeName}
        onChange={(value) => {
          onSelectDateRangeName(value);
        }}
      />
    </div>
  );
};
